import ViewTicketPage from "../../components/ViewTicketPage";

export default function TicketPage() {
  return<ViewTicketPage title="MIS TICKETS"/>
}